import React, { useState } from "react";
import { Link as LinkScroll } from "react-scroll";
import { Link } from "gatsby";
import "./Footer.css";
import { navigate } from "gatsby";

const Footer = ({ home }) => {
  const [subscription, setSubscription] = useState("");

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const addSubscription = (evt) => {
    evt.preventDefault();
    var xhr = new XMLHttpRequest();
    var url =
      "https://api.hsforms.com/submissions/v3/integration/submit/8753452/5f229745-b6ff-4908-93f8-bdbcbff83a1e";
    var data = {
      fields: [
        {
          name: "email",
          value: subscription,
        },
      ],
      context: {
        pageUri: "www.enviary.com",
        pageName: "Home Page",
      },
    };

    var final_data = JSON.stringify(data);

    xhr.open("POST", url);
    // Sets the value of the 'Content-Type' HTTP request headers to 'application/json'
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        navigate(
          "https://enviary.com/thank-you-for-subscription?utm_source=newsletter-subscription&utm_medium=Newsletter%20Subscriptoin%20Button&utm_campaign=Enviary's%20Internal%20Clicks%20Tracking&utm_term=enviary&utm_content=newsletter"
        );

        setSubscription("");
      } else if (xhr.readyState === 4 && xhr.status === 403) {
        alert(xhr.responseText); // Returns a 403 error if the portal isn't allowed to post submissions.
      } else if (xhr.readyState === 4 && xhr.status === 404) {
        alert(xhr.responseText); //Returns a 404 error if the formGuid isn't found
      }
    };

    // Sends the request
    xhr.send(final_data);
  };
  return (
    <div className="footer">
      <div className="footer__top">
        <img
          src={require("../Img/Logo.png")}
          alt="Logo"
          onClick={() => navigate("/")}
        />
        <hr />
        <p>3 Western Road, Canford Cliffs, Poole, Dorset, UK</p>
      </div>
      <div className="footer__middle">
        <ul>
          <li>
            {home ? (
              <LinkScroll
                className="link"
                to="home"
                smooth={true}
                duration={1000}
              >
                home
              </LinkScroll>
            ) : (
              <Link className="link" to="/">
                home
              </Link>
            )}
          </li>
          <li>
            {home ? (
              <LinkScroll
                className="link"
                to="aboutus"
                smooth={true}
                duration={1000}
              >
                about us
              </LinkScroll>
            ) : (
              <Link className="link" to="/#aboutus">
                aboutus
              </Link>
            )}
          </li>
          <li>
            {home ? (
              <LinkScroll
                className="link"
                to="whyus"
                smooth={true}
                duration={1000}
              >
                why enviary
              </LinkScroll>
            ) : (
              <Link className="link" to="/#whyus">
                why enviary
              </Link>
            )}
          </li>
          <li>
            {home ? (
              <LinkScroll
                className="link"
                to="services"
                smooth={true}
                duration={1000}
              >
                services
              </LinkScroll>
            ) : (
              <Link className="link" to="/#services">
                services
              </Link>
            )}
          </li>
          <li>
            <button
              className="link"
              onClick={() =>
                navigate("https://meetings.hubspot.com/enviary/discovery-call")
              }
            >
              book free consultation
            </button>
          </li>
        </ul>

        <div className="subscription_form">
          <div className="social">
            <img
              className="icon"
              src={require("../Img/Facebook.png")}
              alt="Facebook"
              onClick={() =>
                openInNewTab("https://www.facebook.com/enviaryofficial")
              }
            />
            <img
              className="icon"
              src={require("../Img/Linkedin.png")}
              alt="Linkedin"
              onClick={() =>
                openInNewTab("https://www.linkedin.com/company/enviary")
              }
            />
            <img
              className="icon"
              src={require("../Img/Twitter.png")}
              alt="Twitter"
              onClick={() =>
                openInNewTab("https://twitter.com/enviaryofficial")
              }
            />
          </div>
          <p>
            Subscribe & Access Proven Klaviyo Strategy Guide to Improve ROI
            Yourself.
          </p>

          <form onSubmit={addSubscription}>
            <input
              type="email"
              placeholder="Your Email"
              value={subscription}
              onChange={(event) => setSubscription(event.target.value)}
              required
            />
            <button type="submit">Get Access to Proven Strategy</button>
          </form>
        </div>
      </div>
      <div className="footer__bottom">
        <hr />
        <span>
          &#169; 2021 - ENVIARY - An eCommerce Email Marketing Automation
          Agency.
        </span>
      </div>
    </div>
  );
};

export default Footer;
